import React, { type PropsWithChildren, type ReactNode } from "react";
import { useI18n } from "../../../utils/hooks/use.i18n";
import {
  PermissionOptions,
  type PermissionOptionsProps,
} from "./PermissionOptions";
import { PermissionsRow, type PermissionsRowProps } from "./PermissionsRow";

interface PermissionsBarProps {
  containerProps?: PermissionsRowProps["containerProps"];
  isLoading?: boolean;
  label: ReactNode;
  options: PermissionOptionsProps["options"];
}

export const PermissionsBar = ({
  children,
  containerProps,
  isLoading,
  label,
  options,
}: PropsWithChildren<PermissionsBarProps>) => {
  const tPermissionBar = useI18n("PERMISSION_BAR.");

  return (
    <PermissionsRow
      containerProps={containerProps}
      isLoading={isLoading}
      label={label}
    >
      {tPermissionBar("HAS")}
      <PermissionOptions options={options} />
      {tPermissionBar("ACCESS")}
      {children}
    </PermissionsRow>
  );
};
